
Directives.UserInfoDirective =  function UserInfoDirective(){

    // @ngInject
    function UserInfoDirectiveControllerFunc($validation, AnalyticsService, ModalService, UsersManager, PopupMessageService, $scope, $injector, $translate){

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'UserInfoDirectiveController';
        this.validation = $validation;
        this.AnalyticsService = AnalyticsService;
        this.ModalService = ModalService;
        this.UsersManager = UsersManager;
        this.PopupMessageService = PopupMessageService;

        this.placeholderJobTitle ="";
        this.authenticationCompleted = false;
        this.currentUserEmail = this.user.email;
        this.changingEmail = false;
        this.isClient = this.user.isClient();

        var self = this;

        if(!self.user.isClient()){
            self.placeholderJobTitle = $translate.instant('ACCOUNT.PLACEHOLDERS._JOB_');
        }

        this.updateUserData = function updateUserData() {
            self.userData = {
                _id: this.user._id,
                job_title: this.user.job_title,
                email: this.user.email,
                phone_number: this.user.phone_number,
                full_name: this.user.full_name,
                personal_address: this.user.address
            };
        };

        self.updateUserData();

        this.onUpdateSuccess = function onModelUpdateSuccess() {
            self.updateUserData();
        };

        this.onUpdateError = function onModelUpdateError() {
//            self.updateUserData();
//            alert('error saving user');
        };

        this.authenticateUser = function authenticateUser() {
            var self = this;

            var analyticsArgs = {
                user_id: self.user._id,
                current_email: self.currentUserEmail
            };

            self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.user_clicked_email_field, analyticsArgs);

            if (!self.authenticationCompleted) {
                self.PopupMessageService.showConfirm(self.PopupMessageService.severityTypes.warning,
                    'In order to change your email, you are required to complete 2FA authentication using your phone.',
                    function ok(){
                        self.ModalService.openTwoFactorAuthModal(true).then(
                            function confirm(result) {
                                self.onTwoFactorAuthDone(result);
                            },
                            function cancel(error) {
                                self.onTwoFactorAuthDone(error);
                            }
                        );
                    },
                    function cancelled(){
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.user_cancelled_on_2fa_heads_up_popup, analyticsArgs);
                    },
                    'Continue',
                    'Cancel');
            }
        };

        this.updateUserEmail = function updateUserEmail() {
            var self = this;

            var analyticsArgs = {
                user_id: self.user._id,
                old_email: self.currentUserEmail,
                new_email: self.userData.email
            };

            if(!self.verificationCode) {
                return;
            }

            if(self.user.isClient()){
                return;
            }

            self.changingEmail = true;
            self.UsersManager.updateUserEmail(self.userData.email, self.verificationCode)
                .then(function success() {
                    self.currentUserEmail = self.userData.email;
                    self.updateUserData();
                    self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.info, 'Your email has been successfully changed' );
                    self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.user_email_change_success, analyticsArgs);
                })
                .catch(function error(result) {
                    self.userData.email = self.currentUserEmail;
                    self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.error,  result.data.error_message || 'Error updating your email. Please contact our support at concierge@honeybook.com)');
                    self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.user_email_change_failure, analyticsArgs);
                })
                .finally(function finallyDo() {
                    self.changingEmail = false;
                    self.authenticationCompleted = false;
                });
        };

        this.onTwoFactorAuthDone = function onTwoFactorAuthDone(result) {

            var self = this;

            var analyticsArgs = {
                user_id: self.user._id,
                current_email: self.currentUserEmail,
                verification_result: result
            };

            // if verification failed, show message
            if(result === 'invalid') {
                self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.two_factor_auth_failure, analyticsArgs);
                self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.info, 'Invalid verification code. Please retry' );
                return;
            }

            // dismissed
            if(result === 'cancel') {
                return;
            }

            // all good, code is verified!
            self.authenticationCompleted = true;
            self.verificationCode = result;
            self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.info, 'Validation in process. You may change your email now' );
        },

        this.updateUserProperties = function updateUserProperties(form){

            if (!form.$dirty) return;

            var self = this;

            self.isSavingIndicatorActive.value = true;

            if (form.$valid) {
                self.userData.first_name = form.full_name.$viewValue.split(' ')[0];
                self.userData.last_name = form.full_name.$viewValue.split(' ').slice(1).join(' ');
                self.userData.address = form.personal_address.$viewValue;

                self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.user_changed_personal_info, self.userData);
                self.UsersManager.updateUserProperties(self.userData, self.user, true).then(
                    self.onUpdateSuccess,
                    self.onUpdateError
                );
            }
        };

        this.changeProfilePhoto = function changeProfilePhoto() {
            this.ModalService.openUploadProfilePhotoModal(this.user);
        }
    }


    var UserInfoDirectiveController = Class(Controllers.BaseController, {
        constructor: UserInfoDirectiveControllerFunc
    });

    return {
        scope:{
            user: '=user',
            isSavingIndicatorActive: '=isSavingIndicatorActive',
            hideUserAvatar: '=hideUserAvatar',
        },

        templateUrl : 'angular/app/modules/core/features/settings/account/user_info/user_info_template.html',
        controller : UserInfoDirectiveController,
        controllerAs : 'userInfoVm',
        bindToController : true
    }
};